const state = {
  items: [],
  total: 0.00
}

export default state
